function getErrorMessages(errorValue) {
  const errors = Array.isArray(errorValue?.error) ? errorValue.error : [];
  return errors
    .map((item) => item?.message)
    .filter(Boolean);
}

function getErrorMessageHtml(errorValue, fallbackMessage = "Lo sentimos, ha ocurrido un problema") {
  const messages = getErrorMessages(errorValue);
  if (messages.length > 0) {
    const listItems = messages.map((message) => `<li>${message}</li>`).join("");
    return `<ul>${listItems}</ul>`;
  }

  return errorValue?.message || fallbackMessage;
}

export const errorUtils = {
  getErrorMessages,
  getErrorMessageHtml,
};
